import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit/typography';
import { InlineButton } from '../InlineButton';

export interface ICountDownProps {
  seconds: number;

  onClick(): void;
}

export const CountDown: React.FC<ICountDownProps> = ({ seconds, onClick }) => {
  return (
    <div>
      {seconds > 0 ? (
        <InlineText2 color="text-primary-disabled">Отправить код повторно через {seconds} сек.</InlineText2>
      ) : (
        <InlineButton onClick={onClick}>Отправить код повторно</InlineButton>
      )}
    </div>
  );
};

CountDown.displayName = 'CountDown';
